import { useTranslation } from 'react-i18next';
import { safetyEquipment } from '@/mocks/trainingData';

const ITEM_COUNT = 3;

export default function SafetyAndEquipment() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('training.safety.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('training.safety.title')}
          </h2>
          {String(t('training.safety.sectionTitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('training.safety.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        {/* Image showcase */}
        <div className="relative w-full aspect-[21/9] overflow-hidden mb-12 max-w-[900px] mx-auto">
          <img
            src="/images/generated/training-safety-2026.jpg"
            alt={t('training.safety.imgAlt')}
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          {String(t('training.safety.imgCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[12px] text-foreground-400 tracking-[0.04em] mt-2 text-center">{__s}</p>))}
        </div>

        {/* 3 Feature items */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1000px] mx-auto">
          {Array.from({ length: ITEM_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-50 border border-background-200/60 p-6 text-center cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-900 text-accent-400 group-hover:bg-accent-500 group-hover:text-primary-900 transition-all duration-500 mx-auto mb-4">
                <i className={`${safetyEquipment.items[idx].icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {t(`training.safety.${idx}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`training.safety.${idx}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
